import { Button } from '@/components/shadcn/button'
import { Textarea } from '@/components/shadcn/textarea'
import { useTimeLineFileUploader } from '../TimeLineFileUploader/useTimelineFileUploader'
import { useState } from 'react'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'
import { useGetFileRequirements } from './useGetFileRequirements'
import { usePostTransitionUpdate } from './usePostTransitionUpdate'
import { TimelineFileUploader } from '../TimeLineFileUploader'

export function ReturnFileComponent({
  entityId,
  templateId,
  onCancel: onCancelProp,
}: {
  entityId: number
  templateId: number
  onCancel?: () => void
}) {
  const { appId, projectId } = useAppContext()
  const { mutate: transitionUpdate, isPending } = usePostTransitionUpdate({ entityId, templateId })
  const {
    data: { fileSizeLimit, extensionsAllowed, mimeTypesAllowed },
  } = useGetFileRequirements({ entityId, templateId })

  const accept = mimeTypesAllowed.reduce(
    (acc, mimeType) => {
      acc[mimeType] = extensionsAllowed.map((extension) => extension.toLowerCase())
      return acc
    },
    {} as Record<string, string[]>
  )

  const { files, dragging, selectFiles, dropZoneConfig } = useTimeLineFileUploader(accept, fileSizeLimit)
  const [comment, setComment] = useState('')

  const onConfirm = () => {
    if (!appId || !projectId) return
    const formData = new FormData()
    formData.append('application_id', appId.toString())
    formData.append('project_id', projectId.toString())
    formData.append('entity_id', entityId.toString())
    formData.append('template_id', templateId.toString())
    formData.append('transition', 'Return')
    if (files.length > 0) formData.append('file', files[0], files[0].name)
    if (comment) formData.append('notes', comment)
    transitionUpdate({ formData })
  }

  const onCancel = () => {
    setComment('')
    onCancelProp?.()
  }

  return (
    <div className="flex flex-col gap-2">
      <p className="text-xs text-destructive">
        You are about to return a file. Please provide clear reasons for your decision.
      </p>
      <Textarea placeholder="Reasons for returning file" value={comment} onChange={(e) => setComment(e.target.value)} />
      <TimelineFileUploader
        files={files}
        selectFiles={selectFiles}
        dragging={dragging}
        dropZoneConfig={dropZoneConfig}
      />
      <div className="flex justify-end gap-2">
        <Button onClick={onCancel} size="sm" className="h-7" variant="outline">
          Cancel
        </Button>
        <Button onClick={onConfirm} size="sm" className="h-7">
          Confirm
        </Button>
      </div>
    </div>
  )
}
